import React from 'react'

export default ({ classToServiceMapping, onClick }) => (
  <div
    onClick={onClick}
    className="bg-white border-2 border-gray-200 rounded-lg p-6 cursor-pointer hover:border-primary hover:shadow-md transition-all duration-200"
  >
    <h1 className="text-xl font-bold text-gray-900 mb-2">
      {classToServiceMapping.privilegeClass}
    </h1>
    {classToServiceMapping.duration && (
      <span className="text-sm text-gray-600">
        Duration: {classToServiceMapping.duration}
      </span>
    )}
  </div>
)
